import { Component } from '@theme/component';

/**
 * A dropdown of blog categories (from the `custom.blog_categories` metafield) that
 * navigates to the selected category's filtered blog URL.
 *
 * @typedef {Object} BlogCategorySearchRefs
 * @property {HTMLSelectElement} select - The category select; each option value is a target URL.
 * @extends {Component<BlogCategorySearchRefs>}
 */
class BlogCategorySearch extends Component {
  requiredRefs = ['select'];

  /**
   * Navigates to the selected category's URL.
   */
  search() {
    const url = this.refs.select.value;
    if (url) window.location.href = url;
  }
}

if (!customElements.get('blog-category-search')) {
  customElements.define('blog-category-search', BlogCategorySearch);
}
